<template>
	<div>
		<div class="level">
			<div class="level-left">
				<organisations-filter class="level-item"></organisations-filter>
				<listings-filter class="level-item"></listings-filter>
			</div>
			<div class="level-right">
				<date-filter class="level-item" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
	name: "FiltersListings",
	computed: {
		...mapGetters({
			organisations: "reportFilters/organisations",
			listings: "reportFilters/listings",
			selectedOrganisations: "reportQueries/organisations"
		})
	},
	watch: {
		selectedOrganisations() {
			this.updateListings([]);
		}
	},
	created() {
		this.fetchOrganisations();
		this.fetchListings();
	},
	methods: {
		...mapActions({
			fetchOrganisations: "reportFilters/fetchOrganisations",
			fetchListings: "reportFilters/fetchListings",
			updateListings: "reportQueries/updateListings"
		})
	}
};
</script>
